/* istanbul ignore file */

export enum CSSCalculatedVariables {
    ThemeColor = `--theme-color`,
    ThemeColorFiftyOpacity = `--theme-color-fifty-opacity`,
    ThemeColorSevenOpacity = `--theme-color-seven-opacity`,
}
